<div class="pdfc-form">
  <section class="field">
    <h3 class="field-label">Filename identifier</h3>
    <mat-button-toggle-group
      class="identifier-group"
      aria-label="Filename identifier"
      [value]="identifier"
      (change)="onIdentifierChange($event.value)"
    >
      @for (id of identifiers; track id) {
        <mat-button-toggle [value]="id">
          {{ identifierLabel(id) }}
        </mat-button-toggle>
      }
    </mat-button-toggle-group>
  </section>

  <section class="field">
    <h3 class="field-label">File extensions</h3>
    <mat-button-toggle-group
      class="extensions-group"
      aria-label="File extensions"
      multiple
      [value]="selectedExtensions"
      (change)="onExtensionsChange($event.value)"
    >
      @for (ext of extensions; track ext) {
        <mat-button-toggle [value]="ext">
          {{ extensionLabel(ext) }}
        </mat-button-toggle>
      }
    </mat-button-toggle-group>
    @if (identifier !== null && selectedExtensions.length > 0) {
      <div class="convention-preview">
        @for (ext of selectedExtensions; track ext) {
          <code class="convention-inline">{{ formatConvention(ext) }}</code>
        }
      </div>
    }
  </section>
</div>
